module.exports = __webpack_public_path__ + "img/center-bg-1.f5ede467.png";